// extracted by mini-css-extract-plugin
export default {"input":"Search_input__0RCU7","inner":"Search_inner__I8bMK","download":"Search_download__6C7vi"};